import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'unistore/preact';
import { actions } from 'actions';
import CheckboxQuestionOption from 'components/questions/CheckboxQuestionOption';
import { stringReplace } from 'utils';
import classNames from 'classnames';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/CheckboxQuestion.scss';

const CheckboxQuestion = ({ question, onOptionChanged, isDisabled, horizontalOptionsEnabled = false }) => {
  const { options, id, text } = question;

  const qItemId = stringReplace(id, 'cb/', '');

  return (
    <fieldset className={classNames('csw-fieldset csw-q-cbx', {
      'csw-q-cbx-horizontal-options': horizontalOptionsEnabled
    })}>
      <legend className="sr-only" aria-hidden={true}>{text}</legend>
      <ul className="csw-option-list" role="group">
        {options && options.map((optionDetail, index) => {
          const cbxName = `csw-q-cbx-${qItemId}`;
          const cbxKey = `${cbxName}-${optionDetail.id}-${index}`;

          return (<CheckboxQuestionOption key={cbxKey}
                                          i={index}
                                          checkboxName={cbxName}
                                          option={optionDetail}
                                          isDisabled={isDisabled}
                                          onCheckboxChange={(option) => onOptionChanged({ option })}/>);
        })}
      </ul>
    </fieldset>
  );
};

CheckboxQuestion.propTypes /* remove-proptypes */ = {
  question: PropTypes.object.isRequired,
  onOptionChanged: PropTypes.func,
  isDisabled: PropTypes.bool,
  horizontalOptionsEnabled: PropTypes.bool
};

export default connect('questionsData', actions)(CheckboxQuestion);
